<template>
    <div class="resources-folder-grid">
        <ResourcesFolderCard
            v-for="file in topLevelFiles"
            :id="file.id"
            :key="file.id"
            :description="file.description"
            :file-count="fileCount(file.id)"
            :image="file.thumbnail"
            :title="file.name"
        />
    </div>
</template>

<script>
import ResourcesFolderCard from './ResourcesFolderCard';
export default {
    name: 'ResourcesFolderGrid',
    components: { ResourcesFolderCard },
    props: {
        files: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        topLevelFiles() {
            return this.files.filter(it => it.parent == undefined);
        },
    },
    methods: {
        fileCount(id) {
            return this.files.filter(it => it.parent == id).length;
        },
    },
};
</script>

<style scoped>
.resources-folder-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
}
@media only screen and (max-width: 600px) {
    .resources-folder-grid {
        grid-template-columns: 1fr;
    }
}
</style>
